module.exports = __webpack_public_path__ + "img/default_file.783e7f5f.png";